module.exports = __webpack_public_path__ + "img/ao.65a5647.png";